import { gql } from '@apollo/client'
import { PAGINATION_FRAGMENT } from '../Fragments'
export const LEGAL_NOTICES_PROVIDERS_QUERY = gql`
  query LegalNoticeProviders {
    legalNoticeProviders {
      key
      label
      statuses
    }
  }
`
export const LEGAL_NOTICE_INDEX_FRAGMENT = gql`
  fragment LegalNoticeIndexFragment on LegalNoticeIndex {
    id
    provider
    status
    publicationDate
    createdAt
    reference
    customerReference
    departmentCode
    priceHt
    priceTtc
    externalRef
    externalId
    legalFormalityId
    societyName
    email
  }
`
export const LEGAL_NOTICES_INDEX_PAGINATED_FRAGMENT = gql`
  fragment LegalNoticesIndexPaginatedFragment on LegalNoticesIndexPaginated {
    pagination {
      ...PaginationFragment
    }
    legalNotices {
      ...LegalNoticeIndexFragment
    }
  }
  ${LEGAL_NOTICE_INDEX_FRAGMENT}
  ${PAGINATION_FRAGMENT}
`
export const LEGAL_NOTICES_INDEX_QUERY = gql`
  query LegalNoticesIndexPage(
    $provider: String!
    $pagination: PaginationInput!
    $filters: [FilterInput!]
    $search: SearchInput
  ) {
    legalNoticesIndexPage(
      provider: $provider
      pagination: $pagination
      filters: $filters
      search: $search
    ) {
      ...LegalNoticesIndexPaginatedFragment
    }
  }
  ${LEGAL_NOTICES_INDEX_PAGINATED_FRAGMENT}
`
